module.exports = __webpack_public_path__ + "static/fonts/Roboto500.d52f011b.ttf";